<div class="content-wrapper blog-taxonomy-page">
    <div class="content-body">
        <section class="d-flex align-items-center justify-content-between mb-2">
            <div>
                <button type="button" class="btn btn-link p-0 text-muted" routerLink="/blogs">
                    <i class="fa fa-arrow-left mr-1"></i> Back to posts
                </button>
                <h2 class="mt-1 mb-0">Categories</h2>
                <p class="text-muted mb-0">Organize posts into top-level sections</p>
            </div>
            <button class="btn btn-primary" (click)="openCreate()">
                <i class="fa fa-plus mr-1"></i> New Category
            </button>
        </section>

        <div class="card">
            <div class="card-body p-0">
                <table class="table mb-0 align-middle">
                    <thead class="bg-light">
                    <tr>
                        <th>Name</th>
                        <th>Slug</th>
                        <th class="d-none d-md-table-cell">Description</th>
                        <th class="text-center">Posts</th>
                        <th class="text-center">Status</th>
                        <th class="text-right">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let c of categories">
                        <td><strong>{{ c.name }}</strong></td>
                        <td><code>{{ c.slug }}</code></td>
                        <td class="d-none d-md-table-cell text-muted">{{ c.description || '—' }}</td>
                        <td class="text-center">{{ c.blogs_count || 0 }}</td>
                        <td class="text-center">
                            <span class="badge"
                                  [class.badge-success]="c.status === 'ACTIVE'"
                                  [class.badge-secondary]="c.status !== 'ACTIVE'">
                                {{ c.status }}
                            </span>
                        </td>
                        <td class="text-right">
                            <button class="btn btn-sm btn-outline-primary btn-icon mr-1" (click)="openEdit(c)" aria-label="Edit">
                                <span [data-feather]="'edit-2'" [size]="14"></span>
                            </button>
                            <button class="btn btn-sm btn-outline-danger btn-icon" (click)="remove(c)" aria-label="Delete">
                                <span [data-feather]="'trash-2'" [size]="14"></span>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="!loading && categories.length === 0">
                        <td colspan="6" class="text-center text-muted py-4">No categories yet.</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <ng-template #formModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{ editing ? 'Edit Category' : 'New Category' }}</h5>
                <button class="btn btn-sm btn-light btn-icon" (click)="modal.dismiss()" aria-label="Close">
                    <span [data-feather]="'x'" [size]="16"></span>
                </button>
            </div>
            <form [formGroup]="form" (ngSubmit)="submit(modal)">
                <div class="modal-body">
                    <label class="field-label">Name</label>
                    <input type="text" class="form-control" formControlName="name" autofocus>
                    <small class="text-danger"
                           *ngIf="form.get('name').touched && form.get('name').errors?.required">
                        Name is required
                    </small>

                    <label class="field-label mt-3">Description</label>
                    <textarea class="form-control" rows="2" formControlName="description"></textarea>

                    <label class="field-label mt-3">Status</label>
                    <select class="form-control" formControlName="status">
                        <option value="ACTIVE">Active</option>
                        <option value="INACTIVE">Inactive</option>
                    </select>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="saving">
                        {{ editing ? 'Save' : 'Create' }}
                    </button>
                </div>
            </form>
        </ng-template>
    </div>
</div>
